import {
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'axis-icon,[axis-icon]',
  templateUrl: './icon.component.html',
  host: { class: 'axis-icons notranslate', translate: 'no' }
})
export class IconComponent implements OnInit {
  // @HostBinding('class.axis-icons') axisIcon = true;
  // tslint:disable-next-line: no-input-rename
  @Input('data-color') color = ''; // To apply css in ng9, input name should be data-color.
  // tslint:disable-next-line: no-input-rename
  @Input('data-size') size = ''; // To apply css in ng9, input name should be data-size.
  @Input() icon = '';
  @Input() type = 'material-icons';
  @Input() font = 'material';
  iconsList = {
    custom: {
      // refresh: 'reload',
      alert: 'danger',
      calendar: 'date_range',
      change: 'edit',
      chart: 'insert_chart',
      check_circle_black: 'success',
      check_circle: 'success',
      check: 'tick',
      clear: 'cross',
      close: 'cross',
      collapse: 'expand_less',
      // doc: 'picture_as_doc',
      download: 'import',
      expand_less: 'chevron_up',
      expand_more: 'chevron_down',
      expand: 'expand_more',
      export: 'upload',
      fast_forward: 'playback_fast_forward',
      fast_rewind: 'playback_rewind',
      favorites: 'heart',
      // file: 'file',
      filter: 'filter_list',
      history: 'restore',
      loading: 'loop',
      loop: 'sync',
      mail: 'email',
      menu: 'list',
      no_results: 'none',
      // pdf: 'pdf',
      place: 'location_on',
      play_arrow: 'play',
      preview: 'file_search',
      print: 'printer',
      remove_circle_outline: 'do_not_enter',
      rewind_arrow: 'playback_rewind',
      save: 'file_checked',
      school: 'mortar_board',
      sign_out: 'power',
      sort_down: 'arrow_drop_down',
      sort_up: 'arrow_drop_up',
      thumb_down: 'dislike',
      thumb_up: 'like',
      time: 'access_time',
      // upload: 'file_upload',
      view_module: 'grid_alt',
      warning: 'danger',
      // xls: 'xls',
      zoom_out_map: 'maximize',
    },
    material: {
      alert: 'error',
      calendar: 'date_range',
      change: 'edit',
      chart: 'insert_chart',
      collapse: 'expand_less',
      download: 'file_download',
      expand: 'expand_more',
      export: 'import_export',
      file: 'insert_drive_file',
      filter: 'filter_list',
      loading: 'loop',
      location: 'location_on',
      no_results: 'block',
      pdf: 'picture_as_pdf',
      preview: 'description',
      sign_out: 'exit_to_app',
      sort_down: 'arrow_drop_down',
      sort_up: 'arrow_drop_up',
      success: 'check_circle',
      time: 'access_time',
      upload: 'file_upload',
    }
  };
  constructor() { }

  ngOnInit() {
    this.checkIfCustomIcon();
    this.checkCustomClass();
    this.updateIcon();
  }

  checkIfCustomIcon() {
    const types = ['copy_to_down', 'doc', 'ppt', 'sortable', 'xls'];
    if (types.indexOf(this.icon) > -1) {
      this.font = 'custom';
    } else {
      return;
    }
  }
  checkCustomClass() {
    if (this.type === 'axis-custom-icons') {
      this.font = 'custom';
    } else {
      return;
    }
  }
  updateIcon() {
    if (this.iconsList[this.font] && this.iconsList[this.font][this.icon]) {
      this.icon = this.iconsList[this.font][this.icon];
    }
  }
}
